module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f4ecefd4a732f5558dc53b0ccd039caa.png";